module.exports = {
      id: "icon-audio-fb-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-audio-fb",
      toString: function () {
        return this.url;
      }
    }